function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="8" viewBox="0 0 12 8" {...props}><path d="M12 2L10.6.6 6 5.2 1.4.6 0 2l6 6z" fillRule="evenodd" fillOpacity=".25" /></svg>;
});